import { CHART_COLORS } from "../../../../../components/app/provider/patient/chart";
import Text from "../../../../../components/Text";
import useDisclosure from "../../../../../hooks/use-disclosure";
import ViewEncounterSummaryDrawer from "../../billings/encounter/ViewEncounterSummaryDrawer";

interface EncounterIdCellProps {
  /** Encounter/appointment UUID used to fetch the summary. */
  encounterId?: string;
  /** Trimmed value displayed in the cell. */
  label?: string;
}

/**
 * "Visit ID" cell. Clicking the id opens the encounter summary in a drawer —
 * the same ViewEncounterSummaryDrawer the Ready-for-Billing table uses on its
 * "view" action. Self-contained so it can be dropped into a column renderer.
 */
const EncounterIdCell = ({ encounterId, label }: EncounterIdCellProps) => {
  const disclosure = useDisclosure(false);

  if (!encounterId) return <Text isTabletext>{label || "-"}</Text>;

  return (
    <>
      <Text
        isTabletext
        c={CHART_COLORS.primary}
        sx={{ cursor: "pointer" }}
        onClick={() => disclosure.open(encounterId)}
      >
        {label}
      </Text>

      <ViewEncounterSummaryDrawer disclosure={disclosure} />
    </>
  );
};

export default EncounterIdCell;
